import { createTheme as createMuiTheme, responsiveFontSizes } from '@mui/material/styles';

import createBaseOptions from './base/create-options';

/**
 * @typedef {import('@mui/material/styles').Theme & import('./base/create-options').BaseVanSiteTheme } VanSiteTheme
 */

/**
 * @param {'mobile' | 'desktop'} deviceType
 * @returns {VanSiteTheme} - The theme object
 */
export const createTheme = (deviceType) => {
  // Create the basic theme object
  let theme = createMuiTheme(
    // Base options available for both dark and light palette modes
    createBaseOptions({ deviceType })
  );

  // Apply responsive fonts
  theme = responsiveFontSizes(theme);

  return theme;
};
